import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { API_ENDPOINTS } from "../config/constants";
import NotificationsPanel from "./NotificationsPanel";

const NotificationBell = () => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const fetchUnreadCount = async () => {
      try {
        const res = await fetch(
          API_ENDPOINTS.NOTIFICATIONS + "?unreadOnly=true&limit=1",
          {
            credentials: "include",
          }
        );
        if (res.ok) {
          const data = await res.json();
          setUnreadCount(data.pagination.unreadCount);
        }
      } catch (err) {
        console.error("Error fetching notifications:", err);
      }
    };

    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 30000); // Poll every 30 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="relative text-gray-400 hover:text-gray-500 transition-colors"
        aria-label="Notifications"
      >
        <FontAwesomeIcon icon={faBell} className="text-md" />
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[8px] rounded-full h-3 w-3 flex items-center justify-center">
            {unreadCount > 99 ? "99+" : unreadCount}
          </span>
        )}
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 bg-black bg-opacity-25 z-40"
            onClick={() => setIsOpen(false)}
          />
          <div className="fixed sm:absolute right-0 sm:mt-2 w-full sm:w-80 z-50 m-0 sm:m-auto max-h-[100vh] sm:max-h-[90vh] overflow-auto">
            <NotificationsPanel onClose={() => setIsOpen(false)} />
          </div>
        </>
      )}
    </div>
  );
};

export default NotificationBell;
